import { ClinicalExaminationsInput } from '../part/calculator-inputs/ClinicalExaminationsInput';
import { OperationsInput } from '../part/calculator-inputs/OperationsInput';
import { WorkforceInput } from '../part/calculator-inputs/WorkforceInput';

export function CalculatorInput(): JSX.Element {

    return (
        <article className='final calculatorInput'>

            <h1>
                <span className="acc-o-badge">Data Inputs from Customer</span>
            </h1>

            <div className='card'>

                <ClinicalExaminationsInput/>
                <OperationsInput/>
                <WorkforceInput/>

            </div>

        </article>
    );
}
